export type FAQItem = {
  question: string;
  answer: string | React.ReactNode;
  isMarkdown?: boolean;
  isOpenByDefault?: boolean;
};

export type ListItem = {
  icon?: string;
  label?: string;
  text: string | React.ReactNode;
};

export enum FAQCategoryType {
  ACCORDION = 'accordion',
  LIST = 'list',
  TABBED = 'tabbed',
}

export type FAQCategory = {
  id: string;
  type: Exclude<FAQCategoryType, FAQCategoryType.TABBED>;
  label: string;
  description?: string | React.ReactNode;
  items: FAQItem[] | ListItem[];
};

export type FAQConfig = {
  title: string;
  type: FAQCategoryType;
  subtitle: string;
  description?: string | React.ReactNode;
  categories?: FAQCategory[];
  items?: FAQItem[] | ListItem[];
};
